import React, { useState, useEffect, useRef } from 'react';

// React Router Dom Link
import { Link } from "react-router-dom";

const Slider = () => {
  const [currentSlidePos, setCurrentSlidePos] = useState(0);
  const [totalSliderVisibleItems, setTotalSliderVisibleItems] = useState(3); // Initial visible items for larger screens
  const sliderContainerRef = useRef(null);

  const slideNext = () => {
    const sliderContainer = sliderContainerRef.current;
    if (sliderContainer) {
      const totalSlidableItems = sliderContainer.children.length - totalSliderVisibleItems;
      setCurrentSlidePos((prevPos) => (prevPos + 1) % (totalSlidableItems + 1));
    }
  };

  const slidePrev = () => {
    const sliderContainer = sliderContainerRef.current;
    if (sliderContainer) {
      const totalSlidableItems = sliderContainer.children.length - totalSliderVisibleItems;
      setCurrentSlidePos((prevPos) =>
        prevPos === 0 ? totalSlidableItems : prevPos - 1
      );
    }
  };

  useEffect(() => {
    const screenWidth = window.innerWidth;

    if (screenWidth < 768) { // You can adjust the breakpoint as needed
      const sliderContainer = sliderContainerRef.current;

      if (sliderContainer) {
        const moveSliderItem = () => {
          // Adjust the percentage to add spacing between cards
          const spacingPercentage = 6.5; // You can adjust this value as needed
          const offsetLeft =
            currentSlidePos * ((100 / totalSliderVisibleItems) + spacingPercentage);
          sliderContainer.style.transform = `translateX(-${offsetLeft}%)`;
        };

        moveSliderItem();
      }
    } else {
      const sliderContainer = sliderContainerRef.current;
      if (sliderContainer) {
        const moveSliderItem = () => {
          const offsetLeft =
            currentSlidePos * (100 / totalSliderVisibleItems);
          sliderContainer.style.transform = `translateX(-${offsetLeft}%)`;
        };
        moveSliderItem();
      }
    }
  }, [currentSlidePos, totalSliderVisibleItems]);


  // Add a window resize event listener to update the number of visible items
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      // Adjust the number of visible items based on screen width
      if (screenWidth < 768) { // Use your preferred breakpoint
        setTotalSliderVisibleItems(1); // Display 1 item for mobile view
      } else {
        setTotalSliderVisibleItems(3); // Display 3 items for larger screens
      }
    };

    // Initialize the number of visible items on component mount
    handleResize();

    // Add the resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="card overview-card">
      <div className="card-content">
        <h1
          className="headline section-title card-title"
          id="overview-label"
        >
          About Him
        </h1>
        <p className="card-text text-capitalize">
          Prabhjeet Singh's dynamic journey spans cinematography, web
          development, lifestyle influence, entrepreneurship, and food
          blogging. A true modern Renaissance figure, he epitomizes
          passion-driven versatility.
        </p>
        <div className="btn-group">
          <button className="btn-icon" aria-label="previous" onClick={slidePrev}>
            <ion-icon name="arrow-back" aria-hidden="true" />
          </button>
          <button className="btn-icon" aria-label="next" onClick={slideNext}>
            <ion-icon name="arrow-forward" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="slider" data-slider>
        <ul className="slider-list" ref={sliderContainerRef}>
          <li className="slider-item">
            <Link to="/blog/1" className="slider-card">
              <figure
                className="slider-banner img-holder"
                style={{ '--width': 507, '--height': 618 }}
              >
                <img
                  src="/assets/images/skill-1.png"
                  width={507}
                  height={618}
                  loading="lazy"
                  alt="Sport"
                  className="img-cover"
                />

              </figure>
              <div className="slider-content">
                <span className="slider-title">Entrepreneur</span>
                <p className="slider-subtitle">Founder: PS Creative Media</p>
              </div>
            </Link>
          </li>
          <li className="slider-item">
            <Link to="/blog/2" className="slider-card">
              <figure
                className="slider-banner img-holder"
                style={{ '--width': 507, '--height': 618 }}
              >
                <img
                  src="/assets/images/skill-2.png"
                  width={507}
                  height={618}
                  loading="lazy"
                  alt="Sport"
                  className="img-cover"
                />
              </figure>
              <div className="slider-content">
                <span className="slider-title">Lifestyle Influencer</span>
                <p className="slider-subtitle">Verified Amazon Influencer</p>
              </div>
            </Link>
          </li>
          <li className="slider-item">
            <Link to="/blog" className="slider-card">
              <figure
                className="slider-banner img-holder"
                style={{ '--width': 507, '--height': 618 }}
              >
                <img
                  src="/assets/images/webDeveloper.webp"
                  width={507}
                  height={618}
                  loading="lazy"
                  alt="Sport"
                  className="img-cover"
                />
              </figure>
              <div className="slider-content">
                <span className="slider-title">
                  Web Application Developer
                </span>
                <p className="slider-subtitle">At PS Creative Media</p>
              </div>
            </Link>
          </li>
          <li className="slider-item">
            <Link to="/blog" className="slider-card">
              <figure
                className="slider-banner img-holder"
                style={{ '--width': 507, '--height': 618 }}
              >
                <img
                  src="/assets/images/swipe-3.jpg"
                  width={507}
                  height={618}
                  loading="lazy"
                  alt="Sport"
                  className="img-cover"
                />
              </figure>
              <div className="slider-content">
                <span className="slider-title">Cinematographer</span>
                <p className="slider-subtitle">Ad Movies & Fashion Videos</p>
              </div>
            </Link>
          </li>
          <li className="slider-item">
            <Link to="/blog" className="slider-card">
              <figure
                className="slider-banner img-holder"
                style={{ '--width': 507, '--height': 618 }}
              >
                <img
                  src="/assets/images/skill-3.jpg"
                  width={507}
                  height={618}
                  loading="lazy"
                  alt="Sport"
                  className="img-cover"
                />
              </figure>
              <div className="slider-content">
                <span className="slider-title">Food Blogger</span>
                <p className="slider-subtitle">At: @prabh_foodiee</p>
              </div>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Slider;
